import { ArrowForward } from '@mui/icons-material';
import { Container } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next'
import SocialLink from './SocialLink';
import { useNavigate } from 'react-router-dom';
import logo from "../Files/IBG Logo without background.svg"
import logoWhite from "../Files/IBG Logo white.svg"
import Waves from './ui/Waves';
import services from "../Data/Services.json"
import produits from "../Data/Produits.json"

interface Props { }

function Footer(props: Props) {
    const translation = useTranslation();
    const t = translation.t;
    const lang = translation.i18n.language === "fr" ? 0 : 1

    const pages = [t("accueil") + '|/', t("apropos") + '|/about', t("contactM") + "|/contact", t("carriere") + "|/career", t("articles") + "|/articles"];

    const isDark = document.documentElement.dataset.theme === 'dark';
    const navigate = useNavigate()
    const go = (link: string) => {
        navigate(link)
        window.scrollTo({ top: 0 })
    };

    return (
        <footer className='ibg-footer'>
            <Waves />
            <Container maxWidth="lg">
                <div className='ibg-footer__top'>
                    <div className='ibg-footer__brand'>
                        <img src={isDark ? logoWhite : logo} alt="IBG Alpha Technology" />
                        <p>{t("titrePage.accueil.descriptionPage")}</p>
                        <SocialLink />
                    </div>
                    <div className='ibg-footer__newsletter'>
                        <span className='ibg-footer__title'>{t("Texte.Accueil.Partie11.titre")}</span>
                        <p>{t("Texte.Accueil.Partie11.sousTitre")}</p>
                        <form className='ibg-footer__form' onSubmit={(e) => e.preventDefault()}>
                            <input placeholder={t("placeholderMail")} type="email" aria-label={t("placeholderMail")} />
                            <button type='submit' aria-label={t("souscrire")}>{t("souscrire")} <ArrowForward fontSize='small' /></button>
                        </form>
                    </div>
                </div>

                <div className='ibg-footer__grid'>
                    <div>
                        <span className='ibg-footer__title'>{t("Texte.Accueil.Partie5.titre")}</span>
                        <ul>
                            {services.map((s: any) => <li key={s.id}><button onClick={() => go('/#services')}>{s.title.split("|")[lang]}</button></li>)}
                        </ul>
                    </div>
                    <div>
                        <span className='ibg-footer__title'>{t("Texte.Accueil.Partie6.titre")}</span>
                        <ul>
                            {produits.map((s: any) => (
                                <li key={s.id}>
                                    <button onClick={() => go('/#products')}>{s.title.split("|")[lang]}</button>
                                    <small>{s.description.split("|")[lang]}</small>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <span className='ibg-footer__title'>{t("Home.navigation")}</span>
                        <ul>
                            {pages.map((p) => <li key={p}><button onClick={() => go(p.split('|')[1])}>{p.split('|')[0]}</button></li>)}
                        </ul>
                    </div>
                    <div>
                        <span className='ibg-footer__title'>{t("Texte.Accueil.Partie7.titre")}</span>
                        <p>{t("Texte.Accueil.Partie7.contenu")}</p>
                        <button className='ibg-footer__cta' onClick={() => go('/contact')}>{t("contactUs")} <ArrowForward fontSize='small' /></button>
                    </div>
                </div>

                <div className='ibg-footer__bottom'>
                    <span>
                        {/* @2023 {t('nom')+" "+t("prenom")+". "+t("copyright")+"."} */}
                        © {new Date().getFullYear()} IBG-Alpha Technology. {t("copyright")}.
                        {/* Build By IBG-Alpha Technologie */}
                    </span>
                    <div className='ibg-footer__legal'>
                        <button>{t("confidentialite")}</button>
                        <button>{t("terme")}</button>
                        <button>{t("cookies")}</button>
                    </div>
                </div>
            </Container>
        </footer>
    )
}

export default Footer
